// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import { Avatar } from 'components/shared/Avatar/Avatar'
import { Table } from 'components/shared/Table/Table'
import { t } from 'ttag'
import { Icon, StarIcon } from 'components/shared/Icon/Icon'

import styles from './CandidateCell.module.scss'

export const CandidateCell = ({
  email,
  name,
  hasIncreasedHeight,
  className = undefined,
  isFavorite = false,
  setFavorite = () => {},
  indentIcon = false,
  active = true,
}) => (
  <Table.Cell type="body" {...{ hasIncreasedHeight }}>
    <span className={styles.cell}>
      <Avatar user={{ email }} />
      <span className={styles.content}>
        <span className={styles.name}>
          <span>{name}</span>
          <span
            className={cx(styles.icon, className, {
              [styles.activeIcon]: isFavorite,
              [styles.indentIcon]: indentIcon,
              [styles.clickable]: active,
            })}
            title={isFavorite ? t`Remove from favorite` : t`Add to favorite`}
            onClick={active ? () => setFavorite(!isFavorite) : undefined}
          >
            <Icon icon={StarIcon} size={24} />
          </span>
        </span>
        <span className={styles.email}>{email}</span>
      </span>
    </span>
  </Table.Cell>
)
